import * as constants from '../../constants/queueActionTypes';
const initialState = {
    queues: [],
    asyncStatus: 'loading',
};
export function queues(state = initialState, action) {
    switch (action.type) {
        case constants.QUEUES_GET_ALL_SUCCEEDED:
            return Object.assign(Object.assign({}, state), { queues: action.queues, asyncStatus: 'succeeded' });
        case constants.QUEUES_GET_ALL_FAILED:
            return Object.assign(Object.assign({}, state), { asyncStatus: 'failed' });
        case 'QUEUE_MODAL_ADD_SUCCEEDED':
            return state.queues.filter((x) => x.id === action.payload.data.id)
                .length > 0 //Don't add existing queues
                ? state
                : Object.assign(Object.assign({}, state), { queues: [action.payload.data, ...state.queues] });
        case 'QUEUE_MODAL_UPDATE_SUCCEEDED': {
            const queuesCopy = Object.assign([], state.queues);
            if (action.payload.data.is_default === true) {
                for (const queueIndex in queuesCopy) {
                    if (queuesCopy[queueIndex].is_default === true) {
                        queuesCopy[queueIndex].is_default = false;
                    }
                }
            }
            return Object.assign(Object.assign({}, state), { queues: queuesCopy.map((m) => m.id === action.payload.data.id ? action.payload.data : m) });
        }
        case 'QUEUE_MODAL_ADD_FAILED':
        case 'QUEUE_MODAL_UPDATE_FAILED':
            return state;
        default:
            return state;
    }
}
